import { render, staticRenderFns } from "./Tenants.vue?vue&type=template&id=4b7a7562&scoped=true"
import script from "./Tenants.vue?vue&type=script&lang=js"
export * from "./Tenants.vue?vue&type=script&lang=js"
import style0 from "./Tenants.vue?vue&type=style&index=0&id=4b7a7562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a7562",
  null
  
)

export default component.exports